<template>
  <div class="contents contents--full layout-wrapper">
    <div class="contents__wrap">
      <div class="sub-top">
        <h3>기관명: {{orgName}}의 품질평가 관리</h3>
        <select v-model="selectedYear" class="year-dropdown" v-if="checkUserId.subRole == null " >
            <option v-for="year in availableYears" :key="year" :value="year">
              {{ year }}
            </option>
        </select>
        <button class="load-button" @click="openFilePicker"  v-if="checkUserId.subRole == null " >엑셀 업로드</button>
        <input type="file" ref="fileInput" @change="uploadExcel" accept=".xlsx, .xls" style="display: none;"  />
        <button class="load-button" @click="saveExcelData"  v-if="selectedYear != '2025' && checkUserId.subRole == null">
          전년도 엑셀 데이터 저장하기
        </button>
        <button class="load-button" @click="loadYearData"  v-if="selectedYear != '2025'">
          전년도 데이터 불러오기
        </button>
        <div class="sub-top__navi">
          <span class="icon-home navi--home"></span>
          <span>평가</span>
          <span>품질평가 실시</span>
        </div>
      </div>

      <!-- ✅ 도메인 (레벨 1) -->
      <div 
        class="tree-node level-1"
        @click="showDirectEvaluations('내부 감사의 목적(Purpose of Internal Auditing)')"
      >
        <div class="node-title">
          <span class="korean-text">{{ koreanPart('내부 감사의 목적(Purpose of Internal Auditing)') }}</span>
          <span class="english-text">({{ englishPart('내부 감사의 목적(Purpose of Internal Auditing)') }})</span>
        </div>
      </div>

      <!-- ✅ A 도메인 영역 -->
      <div v-if="selectedDomain === '내부 감사의 목적(Purpose of Internal Auditing)'" class="evaluation-list">
        <div 
          v-for="evaluation in directEvaluations" 
          :key="evaluation.evaluationCode" 
          class="tree-node level-4"
        >
          <div class="tree-node__header">
            <span class="node-title">{{ evaluation.evaluationCode }} - {{ evaluation.evaluationName }}</span>
          </div>

          <!-- 현황 입력 -->
          <div class="input-group" :readonly="evaluation.completedYn === 'Y'" >
            <div class="textarea-wrapper full-width">
              <label>현황:</label>
              <textarea 
                :placeholder="`현황을 기재해주세요`"
                v-model="evaluation.content_A" 
              
              ></textarea>
            </div>
          </div>

          <!-- 개선사항 입력 -->
          <div class="input-group">
            <div class="textarea-wrapper full-width">
              <label>개선사항:</label>
              <textarea 
                :placeholder="`개선사항을 기재해주세요`"
                v-model="evaluation.improvement_A" 
              
              ></textarea>
            </div>
          </div>

          <!-- 개선 권고사항항 입력 -->
          <div class="input-group">
            <div class="textarea-wrapper full-width">
              <label>개선 권고사항:</label>
              <textarea 
                :placeholder="`개선 권고사항을 입력하세요.`"
                v-model="evaluation.eqcComment_A" 
              ></textarea>

              <div class="return-button-wrapper">
                <button
                  class="return-button"
                    @click="markFeedbackAsComplete_A(evaluation)"
                    >
                  개선권고사항 없음
                </button>
              </div>
            </div>
          </div>

          <!-- 점수 선택 슬라이더 -->
          <div class="input-group" >
            <label>점수:</label>
            <div class="custom-slider">
              <input 
                type="range"
                v-model="evaluation.score_A"
                min="0"
                max="5"
                step="1"
                @input="updateSlider(evaluation.evaluationCode, $event)"
               
              />
              <div 
                class="slider-thumb"
                :style="{
                  left: `${(evaluation.score_A - 1 ) * 20}%`,
                  background:getSliderColor(evaluation.score_A)
                }"
               
              >
                {{ evaluation.score_A == 0 
                    ? '➡' 
                    : `${evaluation.score_A}점` }}
              </div>
            </div>
          </div>


          <!-- 첨부파일 업로드 -->
          <div class="input-group" v-if="checkUserId.subRole == null">
            <label>첨부파일:</label>
            <input 
              type="file" 
              :id="`file_${evaluation.evaluationCode}`" 
              @change="handleFileUpload_A(evaluation.evaluationCode, $event)" 
              multiple 
              
            />
          </div>

          <!-- 업로드된 파일 목록 -->
          <ul class="" :readonly="evaluation.iqcCompletedYn_A =='Y'">
            <li 
              v-for="(file, fileIndex) in evaluation.files" 
              :key="fileIndex"
            >
              {{ file.name }}
              <button @click="removeFile_A(evaluation.evaluationCode, fileIndex)"
              v-if="evaluation.iqcCompletedYn_A !='Y' && checkUserId.subRole == null">❌</button>
            </li>
          </ul>
        </div>
      </div>


      <!-- 로딩 화면 -->
      <div v-if="isLoading" class="loading-overlay">
        <div class="spinner"></div>
        <p>{{ hasData === 'insert' ? '저장 중입니다...' : '수정 중입니다...' }}</p>
      </div>

      <!-- 트리 구조 렌더링 -->
      <div class="evaluation-tree">
        <!-- Level 1: Domain -->
        <div v-for="(domain, domainIndex) in transformedDomains" :key="domainIndex" class="tree-node level-1">
          <div class="tree-node__header" @click="toggleSubItem(domain.domainCode)">
            <div class="node-title">
              <span class="korean-text">{{ koreanPart(domain.domainName) }}</span>
              <span class="english-text">({{ englishPart(domain.domainName) }})</span>
              
            </div>
          </div>

          <!-- Level 2: Principle -->
          <div v-show="subItemsVisibility[domain.domainCode]" class="tree-node__body">
            <div v-for="(principle, principleIndex) in domain.principles" :key="principleIndex" class="tree-node level-2">
              <div class="tree-node__header" @click="toggleSubItemStandard(domain.domainCode, principle.principleCode)">
                <!-- <span class="node-title">{{ principle.principleCode }} - {{ principle.principleName }}</span> -->
                <div class="node-title">
                  <span>{{ principle.principleCode }} - </span>
                  <span class="korean-text">{{ koreanPart(principle.principleName) }}</span>
                  <span class="english-text">({{ englishPart(principle.principleName) }})</span>
                  <div class="help-icon-wrapper">
                    <div class="help-icon">?</div>
                    <!-- 툴팁 -->
                    <span class="tooltip">{{ principle.principleContent }}</span>
                  </div>
                  
                </div>
              </div>

              <!-- Level 3: Standard -->
              <div v-show="subItemsVisibilityStandard[`${domain.domainCode}-${principle.principleCode}`]" class="tree-node__body">
                <div v-for="(standard, standardIndex) in principle.standards" :key="standardIndex" class="tree-node level-3">
                  <div class="tree-node__header" @click="toggleSubItemEvaluation(domain.domainCode, principle.principleCode, standard.standardCode)">
                    <!-- <span class="node-title">{{ standard.standardCode }} - {{ standard.standardName }}</span> -->
                    <div class="node-title">
                      <span>{{ standard.standardCode }} - </span>
                      <span class="korean-text">{{ koreanPart(standard.standardName) }}</span>
                      <span class="english-text">({{ englishPart(standard.standardName) }})</span>
                      <div class="help-icon-wrapper" v-if="standard.standardContent">
                        <div class="help-icon">?</div>
                        <!-- 툴팁 -->
                        <span class="tooltip-stand">{{ standard.standardContent }}</span>
                      </div>
                      
                    </div>
                  </div>

                  <!-- Level 4: Evaluation -->
                  <div v-show="evaluationVisibility[`${domain.domainCode}-${principle.principleCode}-${standard.standardCode}`]" class="tree-node__content">
                    <div 
                      v-for="(evaluation, evalKey) in standard.evaluations" 
                      :key="evaluation.evaluationCode" 
                      :id="`evaluation-${evaluation.evaluationCode.replace(/\./g, '-')}`"
                      class="tree-node level-4"
                    >
                      <div class="tree-node__header">
                        {{ evaluation.evaluationCode }} - {{ evaluation.evaluationName }}
                          <!-- 레드닷 표시 -->
                         
                      </div>

                      <div class="input-group"
                      :class="{ 'no-timestamp': !evaluationCurrentTime[evaluation.evaluationCode] }">
                        <div class="textarea-wrapper"
                        :class="{ 'full-width': !evaluationCurrentTime[evaluation.evaluationCode] }">
                          <label>현황:</label>
                          <textarea
                            placeholder="현황을 기재해주세요"
                            v-model="evaluationContent[evaluation.evaluationCode]"
                            
                          ></textarea>
                        </div>
                        <div class="timestamp-box" 
                        v-if="evaluationCurrentTime[evaluation.evaluationCode]">
                          <label>최근 저장 일시:</label>
                          <div class="timestamp">
                            <div 
                              v-if="evaluationCurrentTime[evaluation.evaluationCode]" 
                              
                              @click="resetEvaluationContent(evaluation.evaluationCode)"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrentTime[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent2Time[evaluation.evaluationCode]" 
                            
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent2Time[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent3Time[evaluation.evaluationCode]" 
                              
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent3Time[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent4Time[evaluation.evaluationCode]" 
                              
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent4Time[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent5Time[evaluation.evaluationCode]" 
                              
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent5[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent5Time[evaluation.evaluationCode] }}
                            </div>
                          </div>
                          
                        </div>
                      </div>





                    <!-- 개선사항 입력 -->
                    <div class="input-group"
                    :class="{ 'no-timestamp': !evaluationImpTime[evaluation.evaluationCode] }"
                    >
                      <div class="textarea-wrapper"
                      :class="{ 'full-width': !evaluationImpTime[evaluation.evaluationCode] }"
                      >
                        <label>개선사항:</label>
                        <textarea
                          placeholder="개선사항을 기재해주세요"
                          v-model="evaluationImprovements[evaluation.evaluationCode]"
                          
                        ></textarea>
                      </div>
                      <div class="timestamp-box" v-if="evaluationImpTime[evaluation.evaluationCode]">
                        <label>최근 저장 일시:</label>
                        <div class="timestamp">
                          <div
                            v-if="evaluationImpTime[evaluation.evaluationCode]"
                            @click="resetEvaluationImprovements(evaluation.evaluationCode)"
                           
                            class="timestamp-item"
                          >
                            {{ evaluationImpTime[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp2Time[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp2Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp3Time[evaluation.evaluationCode]"
                            
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp3Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp4Time[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp4Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp5Time[evaluation.evaluationCode]"
                            
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements5[evaluation.evaluationCode] ,iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp5Time[evaluation.evaluationCode] }}
                          </div>
                        </div>
                        
                      </div>
                    </div>


                     <!-- 검토 요청사항 -->
                    <!-- <div class="input-group"
                    :class="{ 'no-timestamp': !evaluationCmtTime[evaluation.evaluationCode] }">
                      <div class="textarea-wrapper"
                      :class="{ 'full-width': !evaluationCmtTime[evaluation.evaluationCode] }"
                      >
                        <label>검토 요청사항:</label>
                        <textarea
                          placeholder="검토 요청사항이 준비중입니다."
                          v-model="evaluationComment[evaluation.evaluationCode]"
                         
                        ></textarea>
                      </div>
                      <div class="timestamp-box" v-if="evaluationCmtTime[evaluation.evaluationCode]" >
                        <label>최근 저장 일시:</label>
                        <div class="timestamp" :readonly="iqcCompletedYn[evaluation.evaluationCode] =='Y'" >
                          <div
                            v-if="evaluationCmtTime[evaluation.evaluationCode]"
                           
                            @click="resetEvaluationComment(evaluation.evaluationCode,iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime2[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime2[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime3[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime3[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime4[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime4[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime5[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment5[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime5[evaluation.evaluationCode] }}
                          </div>
                        </div>
                        <div class="return-button-wrapper">
                        </div>
                      </div>
                    </div> -->
                    

                    <div class="input-group">
                      <div class="textarea-wrapper full-width">
                        <label>개선 권고사항:</label>
                        <textarea
                          placeholder="개선 권고사항을 입력하세요."
                          v-model="eqcComment[evaluation.evaluationCode]"
                        ></textarea>

                        <div class="return-button-wrapper">
                          <button
                            class="return-button"
                             @click="markFeedbackAsComplete(evaluation.evaluationCode)"
                             >
                            개선권고사항 없음
                          </button>
                        </div>

                      </div>
                    </div>
                      

                    <!-- 점수 슬라이더 -->
                    <div class="input-group">
                      <label>점수:</label>
                      <div class="custom-slider">
                        <!-- 슬라이더 -->
                        <input 
                          type="range"
                          :value="evaluationScore[evaluation.evaluationCode]"
                          min="0"
                          max="5"
                          step="1"
                          @input="updateSlider(evaluation.evaluationCode, $event)"
                         
                        />

                        <!-- 슬라이더 핸들 (점수 표시 포함) -->
                        <div 
                          class="slider-thumb"
                          :style="{
                            left: `${(evaluationScore[evaluation.evaluationCode] - 1) * 20}%`,
                            background: getSliderColor(evaluationScore[evaluation.evaluationCode])
                          }"
                        >
                        {{ evaluationScore[evaluation.evaluationCode] == 0 
                          ? '➡' 
                          : `${evaluationScore[evaluation.evaluationCode]}점` }}
                          
                        </div>
                      </div>
                    </div>

                    <!-- 파일 업로드 -->
                    <div class="input-group"  v-if="checkUserId.subRole == null">
                      <label>첨부파일:</label>
                      <input 
                        type="file"
                        @change="handleFileUpload(evaluation.evaluationCode, $event)" 
                        multiple
                        :disabled="iqcCompletedYn[evaluation.evaluationCode] == 'Y'"
                      />
                    </div>

                        <!-- 파일 목록 -->
                      <ul class="attach-list">
                        <li v-for="(file, fileIndex) in evaluationFiles[evaluation.evaluationCode] || []" :key="fileIndex">
                          {{ file.name }}
                          <button @click="removeFile(evaluation.evaluationCode, fileIndex)"
                          v-if="iqcCompletedYn[evaluation.evaluationCode] != 'Y' && checkUserId.subRole == null ">❌</button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 저장 버튼 -->
      <div class="save-button-container" v-if="selectedYear == '2025'">

        <button @click="saveData(hasData)">
          {{ hasData === 'insert' ? '저장' : '저장' }}
        </button>

        <button @click="validateBeforeFinalSave" v-if="hasData != 'insert' && checkUserId.subRole == null">
          검토완료
        </button>

        <button class="Excel-button" @click="downloadExcel" v-if="checkUserId.subRole == null">엑셀 다운로드</button>

        <button class="download-button" @click="downloadAllFilesDirectly" v-if="checkUserId.subRole == null">첨부파일 일괄 다운로드</button>
      </div>

    </div>
  </div>
</template>


<script setup>
import { reactive, ref, computed, onMounted,onUnmounted,toRaw,nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter,useRoute } from 'vue-router'
import { insertGias ,updateGiasFile,getIQCApproveList,updateFeedbackForIQA,
  updateFeedbackCompletionStatus,
  finalizeEvaluation,
  updateGiasByEQC,
  insertEqcComment,
  sendIQCMail,checkSavedGIAS
 } from '@/api/giasinput'
// Vuex 데이터 및 API 호출
import axios from 'axios';
import * as XLSX from "xlsx";
const route = useRoute()
const store = useStore();
const checkUserId = computed(() => store.state.temp.userInfo);

const isLoading = ref(false) // 로딩 상태 변수 추가

// 연도 콤보박스 선택된 값
const selectedYear = ref('2025');

// 연도 목록 (현재 연도부터 과거 5년까지)
const availableYears = ref(
      Array.from({ length: 3 }, (_, i) => new Date().getFullYear() - i)
    );


// Vuex로부터 데이터 가져오기
const domainList = computed(() => store.state.grid.domainData); // 승인된 품질평가 조회
// 저장된 품질평가 조회
const orgEvlList = computed(() => {
	return store.state.grid.evlOrgData
})

// 수정시간을 클릭하면 그 시간에 수정한 내용이 매핑됨됨
const updateEvaluationContent = (evaluationCode, content,iqcCompletedYn) => {
  // 클릭한 시간에 매핑된 내용을 v-model에 업데이트

  if(iqcCompletedYn == 'Y'){
    evaluationContent[evaluationCode] = initialEvaluationContent[evaluationCode]
  }else{
    evaluationContent[evaluationCode] = content;
  }
};
// 현황 돌아가기 버튼
const resetEvaluationContent = (code) => {
  evaluationContent[code] = initialEvaluationContent[code] || ""; // 초기 데이터로 되돌림
};

// 개선사항 업데이트 로직
const updateEvaluationImprovements = (evaluationCode, content,iqcCompletedYn) => {
  if(iqcCompletedYn == "Y"){
    evaluationImprovements[evaluationCode] = initialEvaluationImprovements[evaluationCode];
  }else{
    evaluationImprovements[evaluationCode] = content;
  }
};
// 개선사항 초기화 로직
const resetEvaluationImprovements = (evaluationCode) => {
  evaluationImprovements[evaluationCode] = initialEvaluationImprovements[evaluationCode] || "";
};


// 검토 요청사항 업데이트 로직
const updateEvaluationComment = (evaluationCode, content,iqcCompletedYn) => {
  if(iqcCompletedYn == "Y"){
    evaluationComment[evaluationCode] = initialEvaluationComment[evaluationCode] || "";
  }else{
    evaluationComment[evaluationCode] = content;
  }
};

// 검토 요청사항 초기화 로직
const resetEvaluationComment = (evaluationCode) => {
  evaluationComment[evaluationCode] = initialEvaluationComment[evaluationCode] || "";
};


// 초기 데이터 상태 저장
let initialEvaluationContent = {};
let initialEvaluationImprovements = {};
let initialEvaluationScore = {};
let initialEvaluationComment = {};
let initialEvaluationEQCComment = {};
const hasData = ref(false);
const isSticky = ref(false);

// 점수에 따른 슬라이더 색상 반환
const getSliderColor = (score) => {
  if (score == 0) return '#808080'; // 회색
  if (score == 1) return '#f22805'; // 완전 빨간색
  if (score == 2) return '#f57a64'; // 약한 빨간색
  if (score == 3) return '#FFD700'; // 노란색
  if (score == 4) return '#00FF00'; // 연한 초록색색
  if (score == 5) return '#009000'; // 노란색
  return '#FFFFFF'; // 초록색
};

// 한글 부분 추출 (괄호 밖 텍스트)
const koreanPart = (text) => {
  if (!text) return ''; // text가 null 또는 undefined면 빈 문자열 반환
  return text.match(/^[^(]+/g)?.[0]?.trim() || '';
};

// 영어 부분 추출 (괄호 안 텍스트)
const englishPart = (text) => {
  if (!text) return ''; // text가 null 또는 undefined면 빈 문자열 반환
  return text.match(/\((.*?)\)/)?.[1]?.trim() || '';
};

const fileInput = ref(null);
const rowCount = ref(null); // F열 데이터 개수 저장

// 📌 파일 선택 창 열기
const openFilePicker = () => {
  fileInput.value.click();
};

const evaluationCodes_A = [
  "","A.1","A.2"
]
const evaluationCodes_1 = [
  "","","",
  "1.1.1", "1.1.2", "1.1.3", "1.1.4", "1.1.5",
  "1.2.1", "1.2.2", "1.2.3", "1.2.4", "1.3.1", "1.3.2", "1.3.3",
  "2.1.1", "2.1.2", "2.1.3", "2.1.4", "2.1.5", "2.2.1", "2.2.2",
  "2.2.3", "2.2.4", "2.2.5", "2.3.1", "2.3.2", "2.3.3", "2.3.4",
  "3.1.1", "3.1.2", "3.1.3", "3.1.4", "3.1.5", "3.2.1", "3.2.2",
  "3.2.3", "3.2.4", "3.2.5", "4.1.1", "4.1.2", "4.1.3", "4.1.4",
  "4.2.1", "4.2.2", "4.2.3", "4.2.4", "4.2.5", "4.3.1", "4.3.2",
  "4.3.3", "5.1.1", "5.1.2", "5.1.3", "5.2.1", "5.2.2", "5.2.3",
  "5.2.4", "5.2.5", "6.1.1", "6.1.2", "6.1.3", "6.1.4", "6.1.5",
  "6.2.1", "6.2.2", "6.2.3", "6.2.4", "6.2.5", "6.3.1", "6.3.2",
  "6.3.3", "6.3.4", "7.1.1", "7.1.2", "7.1.3", "7.1.4", "7.2.1",
  "7.2.2", "7.2.3", "7.2.4", "8.1.1", "8.1.2", "8.1.3", "8.1.4",
  "8.2.1", "8.2.2", "8.2.3", "8.2.4", "8.2.5", "8.3.1", "8.3.2",
  "8.3.3", "8.4.1", "8.4.2", "8.4.3", "8.4.4", "9.1.1", "9.1.2",
  "9.1.3", "9.2.1", "9.2.2", "9.2.3", "9.2.4", "9.2.5", "9.3.1",
  "9.3.2", "9.3.3", "9.3.4", "9.4.1", "9.4.2", "9.4.3", "9.4.4",
  "9.4.5", "9.5.1", "9.5.2", "9.5.3", "9.5.4", "9.5.5", "10.1.1",
  "10.1.2", "10.1.3", "10.1.4", "10.1.5", "10.2.1", "10.2.2", 
  "10.2.3", "10.2.4", "10.2.5", "10.3.1", "10.3.2", "10.3.3", 
  "10.3.4", "11.1.1", "11.1.2", "11.1.3", "11.1.4", "11.1.5",
  "11.2.1", "11.2.2", "11.2.3", "11.2.4", "11.2.5", "11.3.1",
  "11.3.2", "11.3.3", "11.3.4", "11.4.1", "11.4.2", "11.4.3",
  "11.4.4", "11.5.1", "11.5.2", "11.5.3", "11.5.4", "11.5.5",
  "12.1.1", "12.1.2", "12.1.3", "12.1.4", "12.1.5", "12.2.1",
  "12.2.2", "12.2.3", "12.2.4", "12.2.5", "12.3.1", "12.3.2",
  "12.3.3", "12.3.4", "12.3.5", "13.1.1", "13.1.2", "13.1.3",
  "13.1.4", "13.1.5", "13.2.1", "13.2.2", "13.2.3", "13.2.4",
  "13.2.5", "13.3.1", "13.3.2", "13.3.3", "13.3.4", "13.4.1",
  "13.4.2", "13.4.3", "13.4.4", "13.5.1", "13.5.2", "13.5.3",
  "13.6.1", "13.6.2", "13.6.3", "13.6.4", "14.1.1", "14.1.2",
  "14.1.3", "14.1.4", "14.1.5", "14.2.1", "14.2.2", "14.2.3",
  "14.3.1", "14.3.2", "14.3.3", "14.4.1", "14.4.2", "14.4.3",
  "14.4.4", "14.5.1", "14.5.2", "14.5.3", "14.5.4", "14.6.1",
  "14.6.2", "14.6.3", "14.6.4", "15.1.1", "15.1.2", "15.1.3",
  "15.1.4", "15.2.1", "15.2.2", "15.2.3", "15.2.4"
];

const uploadExcel = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const targetSheetName = "품질평가 결과"; // 🔥 원하는 시트 이름으로 변경

  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: "array" });

    // 🔥 특정 시트 이름이 존재하는지 확인
    if (!workbook.SheetNames.includes(targetSheetName)) {
      alert(`"${targetSheetName}" 시트를 찾을 수 없습니다.`);
      return;
    }

    const worksheet = workbook.Sheets[targetSheetName];

    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    const fColumnData = [];
    const gColumnData = [];
    const iColumnData = [];
    const jColumnData = [];

    // F열과 G열 데이터를 함께 가져오기
    jsonData.forEach(row => {
      const fValue = row[5]; // 점수 F열
      const gValue = row[6]; // 현황 G열
      const iValue = row[8]; // 개선권고사항 I열
      const jValue = row[9]; // 개선사항 J열

      // F열 데이터가 유효한 경우만 추가 (G열도 같은 인덱스에 추가)
      if (fValue !== undefined && fValue !== null && fValue !== "" && fValue !== " ") {
        fColumnData.push(fValue);
        gColumnData.push(gValue || ""); // G열 값이 없을 경우 빈 문자열
        iColumnData.push(iValue || ""); // H열 값이 없을 경우 빈 문자열
        jColumnData.push(jValue || ""); // H열 값이 없을 경우 빈 문자열
      }
    });

    // F열과 G열 데이터를 evaluationContent와 evaluationDate에 매핑
    evaluationCodes_1.forEach((code, index) => {
      evaluationContent[code] = gColumnData[index] || ""; // F열 값 저장
      eqcComment[code] = iColumnData[index] || ""; // G열 값 저장
      evaluationScore[code] = fColumnData[index] || ""; // H열 값 저장
      evaluationImprovements[code] = jColumnData[index] || ""; // H열 값 저장
    });

    evaluationCodes_A.forEach((code, index) => {
      const evaluation = directEvaluations.value.find(item => item.evaluationCode === code);
      if (evaluation) {
        evaluation.content_A = gColumnData[index] || ""; // ✅ F열 값 저장
        evaluation.eqcComment_A = iColumnData[index] || ""; // G열 값 저장
        evaluation.score_A = fColumnData[index] || ""; // ✅ G열 값 저장
        evaluation.improvement_A = jColumnData[index] || ""; // ✅ G열 값 저장
      }
    });

  };
  reader.readAsArrayBuffer(file);
};


const updateSlider = (evaluationCode, event) => {
  // 슬라이더 값이 숫자로 변환되도록 보장
  evaluationScore[evaluationCode] = Number(event.target.value);
};

const handleScroll = () => {
    const stickyThreshold = 150; // 버튼이 고정될 스크롤 위치 (px)
    isSticky.value = window.scrollY > stickyThreshold;
};



// 평가 데이터 하드코딩
const directEvaluations = ref([
  {
    evaluationCode: 'A.1',
    evaluationName: '감사규정 혹은 감사매뉴얼에 내부감사의 성격 및 기능에 대한 내용을 명시',
    content_A: '',
    improvement_A: '',
    comment_A: '',
    score_A: 0,
    completedYn_A : '',
    eqcComment_A : '',
    iqcCompletedYn : '',
    files: []
  },
  {
    evaluationCode: 'A.2',
    evaluationName: '내부감사의 목적, 권한 및 책임은 내부감사의 비전·전략 및 국제내부감사표준과 의미적으로 부합되게 명시',
    content_A: '',
    improvement_A: '',
    comment_A: '',
    score_A: 0,
    completedYn_A : '',
    eqcComment_A : '',
    iqcCompletedYn : '',
    files: []
  }
]);

// 도메인 클릭 이벤트
const selectedDomain = ref(null); // 선택된 도메인

const showDirectEvaluations = (domainName) => {
  if (selectedDomain.value === domainName) {
    // 이미 선택된 도메인이라면 접기
    selectedDomain.value = null;
  } else {
    // 다른 도메인을 클릭하면 펼치기
    selectedDomain.value = domainName;
  }
};

// 파일 업로드 핸들러
const handleFileUpload_A = (evaluationCode, event) => {
  const files = event.target.files;
  if (files && files.length > 0) {
    Array.from(files).forEach((file) => {
      const evalItem = directEvaluations.value.find((item) => item.evaluationCode === evaluationCode);
      if (evalItem) {
        evalItem.files.push(file);
      }
    });
  }
};


// 파일 제거 핸들러
const removeFile_A = (evaluationCode, fileIndex) => {
  const evalItem = directEvaluations.value.find((item) => item.evaluationCode === evaluationCode);
  if (evalItem) {
    // 기존 파일 삭제
    if (evalItem.files[fileIndex]) {
      evalItem.files.splice(fileIndex, 1);
    }

    // 기존 파일 경로 유지
    if (existingFiles[evaluationCode]) {
      existingFiles[evaluationCode].splice(fileIndex, 1);
    }

    console.log(`A 도메인 ${evaluationCode} 파일 삭제됨. 남은 파일:`, evalItem.files);
  }
};

const markFeedbackAsComplete = async (evaluationCode) => {
  eqcComment[evaluationCode] = '개선권고사항 없음'
};
const markFeedbackAsComplete_A = (evaluation) => {
  evaluation.eqcComment_A = '개선권고사항 없음'
};


const handleFileUpload = (evaluationCode, event) => {
  const files = Array.from(event.target.files); // 다중 파일 배열화

  if (!evaluationFiles[evaluationCode]) evaluationFiles[evaluationCode] = [];
  if (!newFiles[evaluationCode]) newFiles[evaluationCode] = [];

  files.forEach((file) => {
    evaluationFiles[evaluationCode].push(file);
    newFiles[evaluationCode].push(file); // 새로 추가된 파일
  });
};

const removeFile = (evaluationCode, fileIndex) => {
  const removedFile = evaluationFiles[evaluationCode].splice(fileIndex, 1)[0];

  // 삭제된 파일을 `deletedFiles`로 이동
  if (existingFiles[evaluationCode]?.some((file) => file.name === removedFile.name)) {
    if (!deletedFiles[evaluationCode]) deletedFiles[evaluationCode] = [];
    deletedFiles[evaluationCode].push(removedFile);
    // 기존 파일 배열에서 삭제
    existingFiles[evaluationCode] = existingFiles[evaluationCode].filter(
      (file) => file.name !== removedFile.name
    );
  } else {
    // 새로 추가된 파일 중 삭제
    newFiles[evaluationCode] = newFiles[evaluationCode].filter(
      (file) => file.name !== removedFile.name
    );
  }
};

//레드닷 전파 로직
const propagateRedDot = (domains) => {
  domains.forEach((domain) => {
    let domainHasRedDot = false;

    domain.principles.forEach((principle) => {
      let principleHasRedDot = false;

      principle.standards.forEach((standard) => {
        let standardHasRedDot = false;

        standard.evaluations.forEach((evaluation) => {
          if (iqcNeedsAttention[evaluation.evaluationCode] === "Y") {
            standardHasRedDot = true;
          }
        });

        // 상위 레벨로 레드닷 상태 전파
        if (standardHasRedDot) {
          principleHasRedDot = true;
          standard.hasRedDot = true; // UI 렌더링용
        }
      });

      if (principleHasRedDot) {
        domainHasRedDot = true;
        principle.hasRedDot = true; // UI 렌더링용
      }
    });

    if (domainHasRedDot) {
      domain.hasRedDot = true; // UI 렌더링용
    }
  });
};


const prepareKeepFiles = () => {
  const keepFiles = {};

  // ✅ 일반 평가 항목 파일
  Object.keys(existingFiles).forEach((code) => {
    keepFiles[code] = existingFiles[code].map((file) => file.path);
  });

  // ✅ A 도메인 파일
  directEvaluations.value.forEach((evaluation) => {
    const code = evaluation.evaluationCode;
    keepFiles[code] = existingFiles[code]?.map((file) => file.path) || [];
  });

  console.log("최종 유지할 파일 목록:", keepFiles);
  return keepFiles;
};


const validateBeforeFinalSave = async () => {
  const emptyEvaluation = Object.keys(eqcComment).find(
    (evaluationCode) => !eqcComment[evaluationCode] || eqcComment[evaluationCode].trim() === ""
  );

  if (emptyEvaluation) {
    alert(`${emptyEvaluation} 코드의 개선 권고사항이 비어 있습니다. 입력 후 다시 시도해주세요.`);

    // 📌 🚀 스크롤 이동 전, 자동으로 모든 노드를 펼침
    await scrollToEvaluation(emptyEvaluation);
    return;
  }

  finalSaveData();
};

const scrollToEvaluation = async (evaluationCode) => {
  // 점(.)을 하이픈(-)으로 변경하여 유효한 ID로 변환
  const safeEvaluationCode = evaluationCode.replace(/\./g, "-");

  // 1️⃣ 📌 해당 평가 코드가 포함된 모든 부모 노드를 자동으로 펼침
  await expandAllParentNodes(evaluationCode);

  // 2️⃣ 📌 Vue의 DOM 업데이트를 기다린 후 스크롤 이동 실행
  await nextTick();

  // 3️⃣ 📌 해당 평가 코드로 스크롤 이동
  const element = document.querySelector(`#evaluation-${safeEvaluationCode}`);

  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  } else {
    console.warn(`ID가 ${safeEvaluationCode}인 요소를 찾을 수 없습니다.`);
  }
};

// ✅ 🚀 **모든 상위 노드를 자동으로 펼치는 함수**
const expandAllParentNodes = async (evaluationCode) => {
  let expanded = false; // 최소 한 개의 노드가 펼쳐졌는지 확인

  for (const key in evaluationVisibility) {
    if (evaluationCode.startsWith(key)) {
      evaluationVisibility[key] = true;
      expanded = true;
    }
  }

  for (const key in subItemsVisibilityStandard) {
    if (evaluationCode.startsWith(key)) {
      subItemsVisibilityStandard[key] = true;
      expanded = true;
    }
  }

  for (const key in subItemsVisibility) {
    if (evaluationCode.startsWith(key)) {
      subItemsVisibility[key] = true;
      expanded = true;
    }
  }

  // **만약 한 개 이상의 노드를 펼쳤다면, Vue의 DOM 업데이트를 기다림**
  if (expanded) {
    await nextTick();
  }
};

const finalSaveData = async () => {
  isLoading.value = true; // 로딩 시작
  try {
    let paramMail = {
      organizationCode : orgCode.value
    }

    let rtnMail = await sendIQCMail(paramMail)
    if (rtnMail?.result == 'ok') {
      alert(orgName.value+"의 IQC에게 이메일을 보냈습니다. ")
      window.location.reload();
    }else{
      alert("이메일 전송에 실패했습니다.")
    }
  } catch (error) {
    console.error("저장 중 오류 발생:", error);
  } finally {
    isLoading.value = false; // 로딩 종료
  }
}




// Save Data 로직 수정
const saveData = async (check) => { 
  isLoading.value = true; // 로딩 시작
  try {
    const result = [];
    const formData = new FormData();

    let isFileLimitExceeded = false;

    // ✅ 일반 평가 항목 처리 (transformedDomains)
    transformedDomains.value.forEach((domain) => {
      domain.principles.forEach((principle) => {
        principle.standards.forEach((standard) => {
          standard.evaluations.forEach((evaluation) => {
            const code = evaluation.evaluationCode;
           
            
            const entry = {
              memberCode: checkUserId.value.memberCode,
              organizationCode: orgCode.value,
              evaluationCode: code,
              evaluationScore: evaluationScore[code] || null,
              evaluationCurrent: evaluationContent[code] || null,
              evaluationImp: evaluationImprovements[code] || null,
              evaluationCmt: evaluationComment[code] || null,
              eqcComment: eqcComment[code] || null,
              orgGiasYear : selectedYear.value,
              completedYn : 'N'
            };
            result.push(entry);

            // 파일 개수 확인
            const existingFileCount = existingFiles[code]?.length || 0;
            const newFileCount = newFiles[code]?.length || 0;
            const totalFileCount = existingFileCount + newFileCount;

            if (totalFileCount > 7) {
              isFileLimitExceeded = true;
            }

            // 새로 추가된 파일
            if (newFiles[code]) {
              newFiles[code].forEach((file) => {
                formData.append(`files[${code}][]`, file);
              });
            }
            
          });
        });
      });
    });

 
      // ✅ A 도메인 평가 항목 처리 (directEvaluations)
    directEvaluations.value.forEach((evaluation) => {
      const code = evaluation.evaluationCode;

      const entry = {
        memberCode: checkUserId.value.memberCode,
        organizationCode: orgCode.value,
        evaluationCode: code,
        evaluationScore: evaluation.score_A || null,
        evaluationCurrent: evaluation.content_A || null,
        evaluationImp: evaluation.improvement_A || null,
        evaluationCmt: evaluation.comment_A || null,
        eqcComment: evaluation.eqcComment_A || null,
        orgGiasYear : selectedYear.value,
        completedYn : 'N'
      };

      result.push(entry);

      // 파일 개수 확인
      const existingFileCount = existingFiles[code]?.length || 0;
      const newFileCount = evaluation.files?.length || 0;
      const totalFileCount = existingFileCount + newFileCount;

      if (totalFileCount > 7) {
        isFileLimitExceeded = true;
      }

      // 새로 추가된 파일
      if (evaluation.files) {
        evaluation.files.forEach((file) => {
          formData.append(`files[${code}][]`, file);
        });
      }
    });

    
    
    // ✅ 파일 제한 초과 시 경고 및 실행 중단
    if (isFileLimitExceeded) {
      alert("첨부파일은 평가 코드당 최대 7개까지만 가능합니다.");
      return;
    }

    // ✅ 유지할 파일
    const keepFiles = prepareKeepFiles();
    formData.append("keepFiles", JSON.stringify(keepFiles));

    formData.append("data", JSON.stringify(result));

    // ✅ 서버로 데이터 전송
    try {      
      if(check === "update") {
        if (confirm("수정 하시겠습니까?")) {
          formData.append("checkString", "Admin");
          formData.append("memberCode", checkUserId.value.memberCode);
          formData.append("orgCode", orgCode.value);
          const response = await updateGiasByEQC(formData);
          if (response.result === "ok") {
            formData.append("organizationCode", orgCode.value);
            const rtn = await updateGiasFile(formData);
            if (rtn.result === "ok") {
              alert("수정에 성공했습니다.");
              window.location.reload();
            } else {
              alert("파일 수정에 실패했습니다.");
            }
          } else {
            alert("수정에 실패했습니다.");
          }
        }
      }

      if(check === "final") {
        if (confirm("평가완료 하시겠습니까? 평가완료 후 수정이 불가능합니다. ")) {
          formData.append("checkString", "Admin");
          formData.append("memberCode", checkUserId.value.memberCode);
          formData.append("orgCode", checkUserId.value.organizationCode);
          const response = await updateGiasByEQC(formData);
          if (response.result === "ok") {
            formData.append("organizationCode", checkUserId.value.organizationCode);
            const rtn = await updateGiasFile(formData);
            if (rtn.result === "ok") {

            } else {
              alert("파일 수정에 실패했습니다.");
            }
          } else {
            alert("수정에 실패했습니다.");
          }
        }
      }


    } catch (error) {
      console.error("저장 중 오류 발생:", error);
      alert("오류가 발생했습니다.");
    }
  } catch (error) {
    console.error("저장 중 오류 발생:", error);
  } finally {
    isLoading.value = false; // 로딩 종료
  }
};

//엑셀데이터 저장장
const saveExcelData = async (check) => { 
  isLoading.value = true; // 로딩 시작
  try {
    const result = [];
    const formData = new FormData();

    let isFileLimitExceeded = false;

    // ✅ 일반 평가 항목 처리 (transformedDomains)
    transformedDomains.value.forEach((domain) => {
      domain.principles.forEach((principle) => {
        principle.standards.forEach((standard) => {
          standard.evaluations.forEach((evaluation) => {
            const code = evaluation.evaluationCode;
           
            const entry = {
              memberCode: checkUserId.value.memberCode,
              organizationCode: orgCode.value,
              evaluationCode: code,
              evaluationScore: evaluationScore[code] || null,
              evaluationCurrent: evaluationContent[code] || null,
              evaluationImp: evaluationImprovements[code] || null,
              evaluationCmt: evaluationComment[code] || null,
              orgGiasYear : selectedYear.value,
              completedYn : 'N',
              eqcComment: eqcComment[code] || null,
              checkUser : 'admin'
            };
            result.push(entry);

            // 파일 개수 확인
            const existingFileCount = existingFiles[code]?.length || 0;
            const newFileCount = newFiles[code]?.length || 0;
            const totalFileCount = existingFileCount + newFileCount;

            if (totalFileCount > 7) {
              isFileLimitExceeded = true;
            }

            // 새로 추가된 파일
            if (newFiles[code]) {
              newFiles[code].forEach((file) => {
                formData.append(`files[${code}][]`, file);
              });
            }
            
          });
        });
      });
    });

    if(checkUserId.value.privilege !== 'user'){
      // ✅ A 도메인 평가 항목 처리 (directEvaluations)
      directEvaluations.value.forEach((evaluation) => {
        const code = evaluation.evaluationCode;

        const entry = {
          memberCode: checkUserId.value.memberCode,
          organizationCode: orgCode.value,
          evaluationCode: code,
          evaluationScore: evaluation.score_A || null,
          evaluationCurrent: evaluation.content_A || null,
          evaluationImp: evaluation.improvement_A || null,
          evaluationCmt: evaluation.comment_A || null,
          orgGiasYear : selectedYear.value,
          completedYn : 'N',
          eqcComment: evaluation.eqcComment_A || null,
          checkUser : 'admin'
        };

        result.push(entry);

        // 파일 개수 확인
        const existingFileCount = existingFiles[code]?.length || 0;
        const newFileCount = evaluation.files?.length || 0;
        const totalFileCount = existingFileCount + newFileCount;

        if (totalFileCount > 7) {
          isFileLimitExceeded = true;
        }

        // 새로 추가된 파일
        if (evaluation.files) {
          evaluation.files.forEach((file) => {
            formData.append(`files[${code}][]`, file);
          });
        }
      });

    }
    
    // ✅ 파일 제한 초과 시 경고 및 실행 중단
    if (isFileLimitExceeded) {
      alert("첨부파일은 평가 코드당 최대 7개까지만 가능합니다.");
      return;
    }

    // ✅ 유지할 파일
    const keepFiles = prepareKeepFiles();
    formData.append("keepFiles", JSON.stringify(keepFiles));

    formData.append("data", JSON.stringify(result));

    // ✅ 서버로 데이터 전송
    try {
      if (confirm("저장 하시겠습니까?")) {
        let param = {
          organizationCode: orgCode.value,
          orgGiasYear : selectedYear.value
        };

        const responseCeheck = await checkSavedGIAS(param);

        if (responseCeheck.result === "ok") { // 데이터가 
          const response = await insertGias(formData);
          if (response.result === "ok") {
            alert("저장에 성공했습니다.");
            window.location.reload();
          } else {
            alert("저장에 실패했습니다.");
          }
        } else {
          const response = await updateGiasByEQC(formData);
          if (response.result === "ok") {
            alert("엑셀 데이터 수정에 성공했습니다.");
            window.location.reload();
          } else {
            alert("엑셀 데이터 수정에 실패했습니다.");
          }
        }
      }
      
    } catch (error) {
      console.error("저장 중 오류 발생:", error);
      alert("오류가 발생했습니다.");
    }
  } catch (error) {
    console.error("저장 중 오류 발생:", error);
  } finally {
    isLoading.value = false; // 로딩 종료
  }
};



// 트리 구조 변환 함수
const transformToTreeStructure = (data) => {
  const groupedData = {};

  data.forEach((item) => {
    if (!groupedData[item.domainCode]) {
      groupedData[item.domainCode] = {
        domainCode: item.domainCode,
        domainName: item.domainName,
        principles: {},
      };
    }
    const domain = groupedData[item.domainCode];

    if (!domain.principles[item.principleCode]) {
      domain.principles[item.principleCode] = {
        principleCode: item.principleCode,
        principleName: item.principleName,
        principleContent:item.principleContent,
        standards: {},
      };
    }
    const principle = domain.principles[item.principleCode];

    if (!principle.standards[item.standardCode]) {
      principle.standards[item.standardCode] = {
        standardCode: item.standardCode,
        standardName: item.standardName,
        standardContent: item.standardContent,
        evaluations: [],
      };
    }
    const standard = principle.standards[item.standardCode];

    standard.evaluations.push({
      evaluationCode: item.evaluationCode,
      evaluationName: item.evaluationName,
    });
  });

  return Object.values(groupedData).map((domain) => ({
    ...domain,
    principles: Object.values(domain.principles).map((principle) => ({
      ...principle,
      standards: Object.values(principle.standards),
    })),
  }));
};


// 트리 변환된 데이터
const transformedDomains = computed(() => transformToTreeStructure(domainList.value));

// 토글 상태
const subItemsVisibility = reactive({});
const subItemsVisibilityStandard = reactive({});
const evaluationVisibility = reactive({});

// 평가 데이터 상태
const evaluationContent = reactive({});
const evaluationContent2 = reactive({});
const evaluationContent3 = reactive({});
const evaluationContent4 = reactive({});
const evaluationContent5 = reactive({});
const evaluationContent6 = reactive({});
//현황 수정 시간
const evaluationCurrentTime = reactive({});
const evaluationCurrent2Time = reactive({});
const evaluationCurrent3Time = reactive({});
const evaluationCurrent4Time = reactive({});
const evaluationCurrent5Time = reactive({});


//개선사항 데이터 상세
const evaluationImprovements = reactive({});
const evaluationImprovements2 = reactive({});
const evaluationImprovements3 = reactive({});
const evaluationImprovements4 = reactive({});
const evaluationImprovements5 = reactive({});
const evaluationImprovements6 = reactive({});

//개선사항 수정 로그 시간
const evaluationImpTime = reactive({});
const evaluationImp2Time = reactive({});
const evaluationImp3Time = reactive({});
const evaluationImp4Time = reactive({});
const evaluationImp5Time = reactive({});

//권고사항 데이터 상세
const evaluationComment = reactive({});
const evaluationComment2 = reactive({});
const evaluationComment3 = reactive({});
const evaluationComment4 = reactive({});
const evaluationComment5 = reactive({});
const evaluationComment6 = reactive({});

//권고사항 수정 로그시간
const evaluationCmtTime = reactive({});
const evaluationCmtTime2 = reactive({});
const evaluationCmtTime3 = reactive({});
const evaluationCmtTime4 = reactive({});
const evaluationCmtTime5 = reactive({});

const evaluationScore = reactive({});
const evaluationFiles = reactive({});
const completedYn = reactive({});
const iqcCompletedYn = reactive({});
const iqaNeedsAttention = reactive({});
const iqcNeedsAttention = reactive({});
const eqcComment = reactive({}); // EQC가 작성한 피드백
//파일 관리 상태
const existingFiles = reactive({}); // 존재하는 파일
const newFiles = reactive({}); // 새로운 파일
const deletedFiles = reactive({}); // 삭제할 파일

// 모든 평가 항목의 수와 iqcCompletedYn === "Y"인 항목 수를 계산
const giasCount = computed(() => Object.keys(iqcCompletedYn).length);
const iqcCompletedYnCount = computed(() =>
  Object.values(iqcCompletedYn).filter((value) => value === "Y").length
);

// 제출 버튼 비활성화 조건 계산
const isSubmitDisabled = computed(() => giasCount.value === iqcCompletedYnCount.value);

// 도메인 토글
const toggleSubItem = (domainCode) => {
  subItemsVisibility[domainCode] = !subItemsVisibility[domainCode];
};

// 프린서펄 토글
const toggleSubItemStandard = (domainCode, principleCode) => {
  const key = `${domainCode}-${principleCode}`;
  subItemsVisibilityStandard[key] = !subItemsVisibilityStandard[key];
};

// 스탠다드 토글
const toggleSubItemEvaluation = (domainCode, principleCode, standardCode) => {
  const key = `${domainCode}-${principleCode}-${standardCode}`;
  evaluationVisibility[key] = !evaluationVisibility[key];
};

const loadYearData = async () => {
  console.log(`📅 선택된 연도: ${selectedYear.value}`);
  alert(`${selectedYear.value}년 데이터를 불러옵니다.`);
  // 여기에 API 호출 또는 데이터 로직 추가
  let param = {
    organizationCode: orgCode.value,
    orgGiasYear : selectedYear.value
  };
  
  await store.dispatch("grid/fetchSelectPreviousYear", param);

  if (Array.isArray(orgEvlList.value)) {
    orgEvlList.value.forEach((savedEvl) => {
      const code = savedEvl.evaluationCode;
      if (code) {
        // ✅ 기존 transformedDomains 매핑
         //현황 내용
        evaluationContent[code] = savedEvl.evaluationCurrent || "";
        evaluationContent2[code] = savedEvl.evaluationCurrent2 || "";
        evaluationContent3[code] = savedEvl.evaluationCurrent3 || "";
        evaluationContent4[code] = savedEvl.evaluationCurrent4 || "";
        evaluationContent5[code] = savedEvl.evaluationCurrent5 || "";
        evaluationContent6[code] = savedEvl.evaluationCurrent6 || "";

        //현황 수정 시간
        evaluationCurrentTime[code] = savedEvl.evaluationCurrentTime || "";
        evaluationCurrent2Time[code] = savedEvl.evaluationCurrent2Time || "";
        evaluationCurrent3Time[code] = savedEvl.evaluationCurrent3Time || ""; 
        evaluationCurrent4Time[code] = savedEvl.evaluationCurrent4Time || "";
        evaluationCurrent5Time[code] = savedEvl.evaluationCurrent5Time || "";

        //개선사항 내용
        evaluationImprovements[code] = savedEvl.evaluationImp || "";
        evaluationImprovements2[code] = savedEvl.evaluationImp2 || "";
        evaluationImprovements3[code] = savedEvl.evaluationImp3 || "";
        evaluationImprovements4[code] = savedEvl.evaluationImp4 || "";
        evaluationImprovements5[code] = savedEvl.evaluationImp5 || "";
        evaluationImprovements6[code] = savedEvl.evaluationImp6 || "";

        // 권고사항 내용용
        evaluationComment[code] = savedEvl.evaluationCmt || "";
        evaluationComment2[code] = savedEvl.evaluationCmt2 || "";
        evaluationComment3[code] = savedEvl.evaluationCmt3 || "";
        evaluationComment4[code] = savedEvl.evaluationCmt4 || "";
        evaluationComment5[code] = savedEvl.evaluationCmt5 || "";
        evaluationComment6[code] = savedEvl.evaluationCmt6 || "";

        //권고사항 수정 시간
        evaluationCmtTime[code] = savedEvl.evaluationCmtTime || "";
        evaluationCmtTime2[code] = savedEvl.evaluationCmt2Time || "";
        evaluationCmtTime3[code] = savedEvl.evaluationCmt3Time || "";
        evaluationCmtTime4[code] = savedEvl.evaluationCmt4Time || "";
        evaluationCmtTime5[code] = savedEvl.evaluationCmt5Time || ""

        //개선사항 수정 시간
        evaluationImpTime[code] = savedEvl.evaluationImpTime || "";
        evaluationImp2Time[code] = savedEvl.evaluationImp2Time || "";
        evaluationImp3Time[code] = savedEvl.evaluationImp3Time || "";
        evaluationImp4Time[code] = savedEvl.evaluationImp4Time || "";
        evaluationImp5Time[code] = savedEvl.evaluationImp5Time || "";

        evaluationScore[code] = savedEvl.evaluationScore !== null ? savedEvl.evaluationScore : 0; // 기본값 0
        completedYn[code] = savedEvl.completedYn || "";
        iqcCompletedYn[code] = savedEvl.iqcCompletedYn || "";
        iqaNeedsAttention[code] = savedEvl.iqaNeedsAttention || "";
        iqcNeedsAttention[code] = savedEvl.iqcNeedsAttention || "";
        eqcComment[code] = savedEvl.eqcComment || "";

        // ✅ 파일 매핑
        const filePaths = [
          savedEvl.evaluationFile1,
          savedEvl.evaluationFile2,
          savedEvl.evaluationFile3,
          savedEvl.evaluationFile4,
          savedEvl.evaluationFile5,
          savedEvl.evaluationFile6,
          savedEvl.evaluationFile7,
        ].filter(Boolean);

        existingFiles[code] = filePaths.map((path) => ({
          name: path.split("/").pop(),
          path: path,
        }));

        evaluationFiles[code] = [...existingFiles[code]];

        // ✅ A 도메인(directEvaluations) 매핑
        const directEval = directEvaluations.value.find(
          (evalItem) => evalItem.evaluationCode === code
        );

        if (directEval) {
          directEval.content_A = savedEvl.evaluationCurrent || "";
          directEval.improvement_A = savedEvl.evaluationImp || "";
          directEval.comment_A = savedEvl.evaluationCmt || "";
          directEval.score_A = savedEvl.evaluationScore || 0;
          directEval.completedYn_A = savedEvl.completedYn || null;
          directEval.iqcCompletedYn_A = savedEvl.iqcCompletedYn || null;
          directEval.eqcComment_A = savedEvl.eqcComment || null;

          // 파일 매핑
          directEval.files = filePaths.map((path) => ({
            name: path.split("/").pop(),
            path: path,
          }));
        }
      }
    });
  }

  // 기본값 0으로 매핑되지 않은 항목 처리
  transformedDomains.value.forEach((domain) => {
    domain.principles.forEach((principle) => {
      principle.standards.forEach((standard) => {
        standard.evaluations.forEach((evaluation) => {
          const code = evaluation.evaluationCode;
          if (!evaluationScore[code]) {
            evaluationScore[code] = 0; // 디폴트 값 0
          }
        });
      });
    });
  });

  propagateRedDot(transformedDomains.value);
};

// 모든 품질평가 항목을 가져오기기
const getGridData = async () => {

  await store.dispatch("grid/fetchGiasAllData");
};

// 파라미터로 넣은 기업의 평가원들이 작성한 모든 데이터를 가져옴
const getEvlData = async () => {
  let param = {
    organizationCode: orgCode.value,
    orgGiasYear : '2025'
  };
  await store.dispatch("grid/fetchAdminEvlOrg", param);

  if (Array.isArray(orgEvlList.value)) {
    orgEvlList.value.forEach((savedEvl) => {
      const code = savedEvl.evaluationCode;
      if (code) {
        // ✅ 기존 transformedDomains 매핑
         //현황 내용
        evaluationContent[code] = savedEvl.evaluationCurrent || "";
        evaluationContent2[code] = savedEvl.evaluationCurrent2 || "";
        evaluationContent3[code] = savedEvl.evaluationCurrent3 || "";
        evaluationContent4[code] = savedEvl.evaluationCurrent4 || "";
        evaluationContent5[code] = savedEvl.evaluationCurrent5 || "";
        evaluationContent6[code] = savedEvl.evaluationCurrent6 || "";

        //현황 수정 시간
        evaluationCurrentTime[code] = savedEvl.evaluationCurrentTime || "";
        evaluationCurrent2Time[code] = savedEvl.evaluationCurrent2Time || "";
        evaluationCurrent3Time[code] = savedEvl.evaluationCurrent3Time || ""; 
        evaluationCurrent4Time[code] = savedEvl.evaluationCurrent4Time || "";
        evaluationCurrent5Time[code] = savedEvl.evaluationCurrent5Time || "";

        //개선사항 내용
        evaluationImprovements[code] = savedEvl.evaluationImp || "";
        evaluationImprovements2[code] = savedEvl.evaluationImp2 || "";
        evaluationImprovements3[code] = savedEvl.evaluationImp3 || "";
        evaluationImprovements4[code] = savedEvl.evaluationImp4 || "";
        evaluationImprovements5[code] = savedEvl.evaluationImp5 || "";
        evaluationImprovements6[code] = savedEvl.evaluationImp6 || "";

        // 권고사항 내용용
        evaluationComment[code] = savedEvl.evaluationCmt || "";
        evaluationComment2[code] = savedEvl.evaluationCmt2 || "";
        evaluationComment3[code] = savedEvl.evaluationCmt3 || "";
        evaluationComment4[code] = savedEvl.evaluationCmt4 || "";
        evaluationComment5[code] = savedEvl.evaluationCmt5 || "";
        evaluationComment6[code] = savedEvl.evaluationCmt6 || "";

        //권고사항 수정 시간
        evaluationCmtTime[code] = savedEvl.evaluationCmtTime || "";
        evaluationCmtTime2[code] = savedEvl.evaluationCmt2Time || "";
        evaluationCmtTime3[code] = savedEvl.evaluationCmt3Time || "";
        evaluationCmtTime4[code] = savedEvl.evaluationCmt4Time || "";
        evaluationCmtTime5[code] = savedEvl.evaluationCmt5Time || ""

        //개선사항 수정 시간
        evaluationImpTime[code] = savedEvl.evaluationImpTime || "";
        evaluationImp2Time[code] = savedEvl.evaluationImp2Time || "";
        evaluationImp3Time[code] = savedEvl.evaluationImp3Time || "";
        evaluationImp4Time[code] = savedEvl.evaluationImp4Time || "";
        evaluationImp5Time[code] = savedEvl.evaluationImp5Time || "";

        evaluationScore[code] = savedEvl.evaluationScore !== null ? savedEvl.evaluationScore : 0; // 기본값 0
        completedYn[code] = savedEvl.completedYn || "";
        iqcCompletedYn[code] = savedEvl.iqcCompletedYn || "";
        iqaNeedsAttention[code] = savedEvl.iqaNeedsAttention || "";
        iqcNeedsAttention[code] = savedEvl.iqcNeedsAttention || "";
        eqcComment[code] = savedEvl.eqcComment || "";

        // ✅ 파일 매핑
        const filePaths = [
          savedEvl.evaluationFile1,
          savedEvl.evaluationFile2,
          savedEvl.evaluationFile3,
          savedEvl.evaluationFile4,
          savedEvl.evaluationFile5,
          savedEvl.evaluationFile6,
          savedEvl.evaluationFile7,
        ].filter(Boolean);

        existingFiles[code] = filePaths.map((path) => ({
          name: path.split("/").pop(),
          path: path,
        }));

        evaluationFiles[code] = [...existingFiles[code]];

        // ✅ A 도메인(directEvaluations) 매핑
        const directEval = directEvaluations.value.find(
          (evalItem) => evalItem.evaluationCode === code
        );

        if (directEval) {
          directEval.content_A = savedEvl.evaluationCurrent || "";
          directEval.improvement_A = savedEvl.evaluationImp || "";
          directEval.comment_A = savedEvl.evaluationCmt || "";
          directEval.score_A = savedEvl.evaluationScore || 0;
          directEval.completedYn_A = savedEvl.completedYn || null;
          directEval.iqcCompletedYn_A = savedEvl.iqcCompletedYn || null;
          directEval.eqcComment_A = savedEvl.eqcComment || null;

          // 파일 매핑
          directEval.files = filePaths.map((path) => ({
            name: path.split("/").pop(),
            path: path,
          }));
        }
      }
    });
  }

  // 기본값 0으로 매핑되지 않은 항목 처리
  transformedDomains.value.forEach((domain) => {
    domain.principles.forEach((principle) => {
      principle.standards.forEach((standard) => {
        standard.evaluations.forEach((evaluation) => {
          const code = evaluation.evaluationCode;
          if (!evaluationScore[code]) {
            evaluationScore[code] = 0; // 디폴트 값 0
          }
        });
      });
    });
  });

  propagateRedDot(transformedDomains.value);
};

let orgName = ref('')
let orgCode = ref('')
let orgMail = ref('')

onMounted(async () => {

  orgName.value = route.query?.organizationName || ''; 
  orgCode.value = route.query?.organizationCode || ''; 
  orgMail.value = route.query?.organizationMail || ''; 
  await getGridData();
  const gridDataAvailable = domainList.value && domainList.value.length > 0;

  await getEvlData();
  const evlDataAvailable = orgEvlList.value && orgEvlList.value.length > 0;

    // 버튼 표시 로직 설정
  if (!gridDataAvailable && !evlDataAvailable) {
      alert("저장할 항목 또는 수정할 항목이 없습니다. 관리자에게 문의해주세요");
      hasData.value = false; // 버튼 숨김
  } else if (gridDataAvailable && !evlDataAvailable) {
      hasData.value = "insert"; // "저장" 버튼
  } else if (gridDataAvailable && evlDataAvailable) {
      hasData.value = "update"; // "수정" 버튼
  } else {
      hasData.value = false; // 버튼 숨김
  }

  if (Array.isArray(orgEvlList.value)) {
    orgEvlList.value.forEach((savedEvl, index) => {
    //console.log(`[${index + 1}] 항목 데이터:`, savedEvl); // 각 항목의 전체 구조 출력

    const code = savedEvl.evaluationCode; // evaluationCode 확인
    if (code) {
        // 데이터 매핑
        evaluationContent[code] = savedEvl.evaluationCurrent || "";
        evaluationImprovements[code] = savedEvl.evaluationImp || "";
        evaluationComment[code] = savedEvl.evaluationCmt || "";
        evaluationScore[code] = savedEvl.evaluationScore || 0;
        completedYn[code] = savedEvl.completedYn || "";
    }
    });
  } 

     // ✅ A 도메인 데이터 초기화
  directEvaluations.value.forEach((evaluation) => {
    initialEvaluationContent[evaluation.evaluationCode] = evaluation.content_A;
    initialEvaluationImprovements[evaluation.evaluationCode] = evaluation.improvement_A;
    initialEvaluationComment[evaluation.evaluationCode] = evaluation.comment_A;
    initialEvaluationScore[evaluation.evaluationCode] = evaluation.score_A;
  });
  console.log("hasData 상태:", hasData.value); // 디버깅용
  window.addEventListener("scroll", handleScroll);

    // 초기 데이터를 깊은 복사로 저장
  initialEvaluationContent = JSON.parse(JSON.stringify(toRaw(evaluationContent)));
  initialEvaluationImprovements = JSON.parse(JSON.stringify(toRaw(evaluationImprovements)));
  initialEvaluationComment = JSON.parse(JSON.stringify(toRaw(evaluationComment)));
  initialEvaluationScore = JSON.parse(JSON.stringify(toRaw(evaluationScore)));
  initialEvaluationEQCComment = JSON.parse(JSON.stringify(toRaw(eqcComment)));

  transformedDomains.value.forEach((domain) => {
    const domainKey = domain.domainCode;
    subItemsVisibility[domainKey] = false;

    // Level 2: 프린서펄 상태 초기화
    domain.principles.forEach((principle) => {
      const principleKey = `${domainKey}-${principle.principleCode}`;
      subItemsVisibilityStandard[principleKey] = false;

      // Level 3: 스탠다드 상태 초기화
      principle.standards.forEach((standard) => {
        const standardKey = `${principleKey}-${standard.standardCode}`;
        evaluationVisibility[standardKey] = false;
      });
    });
  });

});

onUnmounted(() => {
	// 페이지 닫힐 때 해당 리스너 삭제
  const isContentChanged = JSON.stringify(toRaw(evaluationContent)) !== JSON.stringify(initialEvaluationContent);
  const isImprovementsChanged = JSON.stringify(toRaw(evaluationImprovements)) !== JSON.stringify(initialEvaluationImprovements);
  const isCommentChanged = JSON.stringify(toRaw(evaluationComment)) !== JSON.stringify(initialEvaluationComment);
  const isScoreChanged = JSON.stringify(toRaw(evaluationScore)) !== JSON.stringify(initialEvaluationScore);

  if (isContentChanged || isImprovementsChanged || isScoreChanged || isCommentChanged) {
      //saveData(hasData.value); // 데이터가 변경된 경우만 저장
  } 
}) 


const exportToJSON = () => {
  const jsonData = [];

  transformedDomains.value.forEach((domain) => {
    domain.principles.forEach((principle) => {
      principle.standards.forEach((standard) => {
        standard.evaluations.forEach((evaluation) => {
          const evaluationCode = evaluation.evaluationCode;
          const evaluationName = evaluation.evaluationName;

          // 첨부파일 리스트 가져오기
          const attachments = (evaluationFiles[evaluationCode] || []).map((file) => file.name);
          const attachmentList = attachments.length > 0 ? attachments.join(", ") : "첨부파일 없음";

          // JSON 객체 생성
          const entry = {
            도메인: domain.domainName,  // ✅ 도메인 추가
            프린서펄: principle.principleName, // ✅ 프린서펄 추가
            스탠다드: standard.standardName, // ✅ 스탠다드 추가
            평가코드: evaluationCode,
            평가항목명: evaluationName,
            현재평가내용: evaluationContent[evaluationCode] || null,
            개선내용: evaluationImprovements[evaluationCode] || null,
            관리자피드백: evaluationComment[evaluationCode] || null,
            첨부파일: attachmentList, // 첨부파일 리스트 추가
            평가점수: evaluationScore[evaluationCode] || null, // 평가점수를 가장 마지막에 배치
          };

          jsonData.push(entry);
        });
      });
    });
  });

  console.log("생성된 JSON 데이터:", jsonData);
  return jsonData;
};

// 평가 점수 매핑
const evaluationScores = computed(() => {
  const scores = {};
  orgEvlList.value.forEach((item) => {
    if (item.evaluationCode && item.evaluationScore) {
      scores[item.evaluationCode] = item.evaluationScore;
    }
  });
  return scores;
});


// const downloadExcel = () => {
//   const workbook = XLSX.utils.book_new();

//   /** 📊 1. 통계 테이블 시트 생성 */
//   const statsWorksheetData = [];
//   const statsHeaders = [
//     "Domain",
//     "Principle",
//     "Standard",
//     "세부평가코드",
//     "세부평가사항",
//     "세부평가점수",
//     "현황",
//     "첨부파일",
//     "개선권고사항"
//   ];
//   statsWorksheetData.push(statsHeaders);

//   let currentRow = 1;

//   if (directEvaluations.value?.length) {
//     // 구분선(선택): 필요 없으면 이 두 줄 삭제
//     currentRow++;

//     directEvaluations.value.forEach(de => {
//       const attachments = Array.isArray(de.files) ? de.files.map(f => f.name) : [];
//       const attachmentList = attachments.length ? attachments.join(", ") : "첨부파일 없음";

//       const row = [
//         "내부 감사의 목적(Purpose of Internal Auditing)", // Domain
//         "", // Principle
//         "", // Standard
//         de.evaluationCode,
//         de.evaluationName,
//         (de.score_A ?? de.score ?? ""),         // 점수 필드 fallback
//         (de.content_A ?? de.content ?? ""),     // 현황
//         attachmentList,
//         (de.eqcComment_A ?? de.eqcComment ?? "") // 개선권고사항
//       ];
//       statsWorksheetData.push(row);
//       currentRow++;
//     });
//   }

//   // 1) 기존 트리 구조 데이터
//   transformedDomains.value.forEach(domain => {
//     let isFirstDomainRow = true;

//     domain.principles.forEach(principle => {
//       let isFirstPrincipleRow = true;

//       principle.standards.forEach(standard => {
//         let isFirstStandardRow = true;

//         standard.evaluations.forEach(evaluation => {
//           const attachments = (evaluationFiles[evaluation.evaluationCode] || [])
//             .map((file) => file.name);
//           const attachmentList = attachments.length > 0 ? attachments.join(", ") : "첨부파일 없음";

//           const row = [
//             isFirstDomainRow ? domain.domainName : "",
//             isFirstPrincipleRow ? principle.principleName : "",
//             isFirstStandardRow ? standard.standardName : "",
//             evaluation.evaluationCode,
//             evaluation.evaluationName,
//             evaluationScores.value[evaluation.evaluationCode] || "평가중",
//             evaluationContent[evaluation.evaluationCode] || null,
//             attachmentList,
//             eqcComment[evaluation.evaluationCode] || null,
//           ];
//           statsWorksheetData.push(row);
//           currentRow++;

//           isFirstDomainRow = false;
//           isFirstPrincipleRow = false;
//           isFirstStandardRow = false;
//         });
//       });
//     });
//   });

//   // 2) directEvaluations 추가 (같은 시트에 이어서)
//   //    Domain/Principle/Standard 컬럼은 공란으로 두고, 구분용으로 한 줄 타이틀을 넣어줍니다(선택)

//   // 3) 시트 생성/다운로드
//   const statsWorksheet = XLSX.utils.aoa_to_sheet(statsWorksheetData);
//   XLSX.utils.book_append_sheet(workbook, statsWorksheet, "품질평가 결과");
//   XLSX.writeFile(workbook, `${orgName.value}_통계_전체_테이블.xlsx`);
// };


const downloadExcel = () => {
  const workbook = XLSX.utils.book_new();

  /** 📊 1. 통계 테이블 시트 생성 */
  const statsWorksheetData = [];
  const statsHeaders = [
    "Domain",
    "Principle",
    "Standard",
    "세부평가코드",
    "세부평가사항",
    "세부평가점수",
    "현황",
    "첨부파일",
    "개선권고사항",
    "개선사항"
  ];
  statsWorksheetData.push(statsHeaders);

  let currentRow = 1;

  /** ✅ 직접입력 섹션: 항상 구분 행 추가 */
  const DIRECT_DOMAIN = "내부 감사의 목적(Purpose of Internal Auditing)";
  // 필요 없다면 이 구분 행은 제거 가능
  currentRow++;

  // ✅ directEvaluations 내용 추가 (없어도 안전)
  let printedDirectDomain = false;
  (directEvaluations.value || []).forEach(de => {
    const attachments = Array.isArray(de.files) ? de.files.map(f => f.name) : [];
    const attachmentList = attachments.length ? attachments.join(", ") : "첨부파일 없음";

    const row = [
      printedDirectDomain ? "" : DIRECT_DOMAIN,  // 도메인은 한 번만
      "",                                        // Principle
      "",                                        // Standard
      de.evaluationCode,
      de.evaluationName,
      (de.score_A ?? de.score ?? ""),            // 세부평가점수
      (de.content_A ?? de.content ?? ""),        // 현황
      attachmentList,                            // 첨부파일
      (de.eqcComment_A ?? de.eqcComment ?? ""),   // 개선권고사항
      (de.improvement_A ?? de.improvement_A ?? "")   // 개선사항
    ];
    statsWorksheetData.push(row);
    currentRow++;
    printedDirectDomain = true;
  });

  /** 🔁 기존 트리 구조 데이터 */
  transformedDomains.value.forEach(domain => {
    let isFirstDomainRow = true;

    domain.principles.forEach(principle => {
      let isFirstPrincipleRow = true;

      principle.standards.forEach(standard => {
        let isFirstStandardRow = true;

        standard.evaluations.forEach(evaluation => {
          const attachments = (evaluationFiles[evaluation.evaluationCode] || [])
            .map((file) => file.name);
          const attachmentList = attachments.length > 0 ? attachments.join(", ") : "첨부파일 없음";

          const row = [
            isFirstDomainRow ? domain.domainName : "",
            isFirstPrincipleRow ? principle.principleName : "",
            isFirstStandardRow ? standard.standardName : "",
            evaluation.evaluationCode,
            evaluation.evaluationName,
            evaluationScores.value[evaluation.evaluationCode] || "평가중",
            evaluationContent[evaluation.evaluationCode] || null,
            attachmentList,
            eqcComment[evaluation.evaluationCode] || null,
            evaluationImprovements[evaluation.evaluationCode] || null,
          ];
          statsWorksheetData.push(row);
          currentRow++;

          isFirstDomainRow = false;
          isFirstPrincipleRow = false;
          isFirstStandardRow = false;
        });
      });
    });
  });

  /** 📥 시트 생성 및 다운로드 */
  const statsWorksheet = XLSX.utils.aoa_to_sheet(statsWorksheetData);
  XLSX.utils.book_append_sheet(workbook, statsWorksheet, "품질평가 결과");
  XLSX.writeFile(workbook, `${orgName.value}_품질평가_데이터.xlsx`);
};


const downloadAllFilesDirectly = async () => {
 try {
    const timestamp = new Date().toISOString().replace(/[-:.]/g, "").slice(0, 14); // YYYYMMDDHHMMSS
    const fileName = `${orgName.value}_품질평가_파일_${timestamp}.zip`;

    // API 호출
    const response = await axios.get(`/gias/download-all-files`, {
      params: { organizationCode: orgCode.value },
      responseType: 'blob', // ZIP 파일 다운로드
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      alert('ZIP 파일 다운로드가 완료되었습니다.');
    } else {
      console.error('ZIP 파일 다운로드 실패: 서버 응답이 올바르지 않습니다.', response);
      alert('ZIP 파일 다운로드에 실패했습니다.');
    }
  } catch (error) {
    console.error('ZIP 파일 다운로드 중 오류 발생:', error);
    alert('ZIP 파일 다운로드 중 오류가 발생했습니다. 관리자에게 문의하세요.');
  }
};


</script>


<style scoped>

/* ✅ Readonly 상태의 textarea 스타일 */
textarea[readonly] {
  background-color: #f0f0f0; /* 회색 배경 */
  color: #666; /* 텍스트 색상 */
  cursor: not-allowed; /* 마우스 커서 */
  border: 1px solid #ccc; /* 경계선 */
}


.year-dropdown {
  margin-left: 10px; /* 간격 추가 */
  padding: 2px 2px; /* 내부 패딩 */
  border: 1px solid #ccc; /* 테두리 스타일 */
  border-radius: 4px; /* 둥근 모서리 */
  font-size: 14px; /* 글꼴 크기 */
  cursor: pointer; /* 포인터 커서 */
  height: 25px;
  width: 50px;
  text-align: center;
}

.year-dropdown:focus {
  border-color: #0078d7; /* 포커스 시 테두리 색상 변경 */
  outline: none;
}

.load-button {
  margin-left: 10px; /* 간격 추가 */
  padding: 5px 15px; /* 내부 패딩 */
  background-color: #0078d7; /* 버튼 배경색 */
  color: white; /* 글자색 */
  border: none; /* 테두리 제거 */
  border-radius: 4px; /* 둥근 모서리 */
  cursor: pointer; /* 포인터 커서 */
  font-size: 14px; /* 글꼴 크기 */
}

.load-button:hover {
  background-color: #005bb5; /* 호버 시 색상 변경 */
}

/* 도움말 아이콘 */
.help-icon-wrapper {
  position: relative;
  display: inline-block;
  margin-right: 8px; /* 프린서펄이름과 간격 추가 */
  margin-left: 8px; /* 레드닷과 간격 추가 */
  vertical-align: middle; /* 아이콘이 텍스트와 중간 정렬되도록 */
}

.help-icon {
  width: 20px;
  height: 20px;
  background-color: #005bb5;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

/* 툴팁 스타일 */
.tooltip {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px; /**줄간격 */
  visibility: hidden;
  background-color: #fff;
  color: #000;
  text-align: left;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: 120%; /* 부모의 중앙을 기준으로 위치 */
  left: 100%; /* 아이콘의 오른쪽에 위치 */
  transform: translate(20px, -50%); /* Y축 -50%로 중앙 정렬 */
  white-space: pre-wrap; /* 줄바꿈 허용 */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  max-width: 700px; /* 최대 너비 제한 */
  width: max-content; /* 내용에 맞춰 너비 설정 */
}

.tooltip-stand {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px; /**줄간격 */
  visibility: hidden;
  background-color: #fff;
  color: #000;
  text-align: left;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: 50%; /* 부모의 중앙을 기준으로 위치 */
  left: 100%; /* 아이콘의 오른쪽에 위치 */
  transform: translate(20px, -50%); /* Y축 -50%로 중앙 정렬 */
  white-space: pre-wrap; /* 줄바꿈 허용 */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  width: 300px;
}

.help-icon-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.help-icon-wrapper:hover .tooltip-stand {
  visibility: visible;
  opacity: 1;
}

.red-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  margin-left: 5px;
  vertical-align: middle;
}
.layout-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 최소 높이를 뷰포트 높이로 설정 */
}
.footer {
  background-color: #FFFFFF; /* 배경색 지정 */
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
}
.attach-list{
  margin-top: -10px;
  font-size: 14px;
  margin-left: 80px;
}
/* ✅ 저장 버튼 */
.save-button-container {
margin-top: 20px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  gap: 10px; /* 버튼 사이 간격 */
}

.save-button-container button {
  background-color: #0078d7;
  color: white;
  border-radius: 5px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

/* ✅ 최종 저장 버튼 스타일 (선택적 스타일 추가) */
.save-button-container button:last-child {
  background-color: #28a745; /* 초록색 버튼 */
}

/* 비활성화 상태 */
button:disabled {
  cursor: not-allowed; /* 금지 커서 */
  opacity: 0.2; /* 투명도 */
}

/* ✅ 트리 노드 스타일 */
.tree-node {
  border: 1px solid #ddd;
  border-radius: 5px;
  margin: 10px 0;
  padding: 14px;
  background-color: #f9fafc;
}

.level-1 {
  background-color: #CDE7FA;
  cursor: pointer;
}

.level-2 {
  background-color: #D7EFFB;
  margin-left: 20px;
}

.level-3 {
  background-color: #E3F2FD;
  margin-left: 20px;
}

.level-4 {
  background-color: #F1F8FE;
  cursor: default ;
  margin-left: 20px;
}

.node-title {
  font-weight: bold;
}
/* 한글 스타일 */
.node-title .korean-text {
  font-size: 16px;
}

/* 영어 스타일 */
.node-title .english-text {
  font-size: 10px;
}

/* ✅ 입력 그룹 */
.input-group {
  display: flex;
  align-items: flex-start; /* 텍스트박스와 수정 시간 정렬 */
  margin: 20px 0;
  gap: 10px; /* 입력창과 수정 시간 간격 추가 */
}

/* ✅ 텍스트 영역 래퍼 */
.textarea-wrapper {
  flex: 0 0 80%; /* 입력창을 80%로 설정 */
}

.textarea-wrapper textarea {
  height: 160px; /* 수정 시간 박스와 동일한 높이 설정 */
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  resize: vertical; /* 사용자가 세로로 크기 조정 가능 */
}

.input-group label {
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
  white-space: nowrap; /* 텍스트가 줄바꿈되지 않도록 설정 */
}

.input-group textarea {
  width: 100%;
  height: 160px; /* 기존 높이에 +15px 추가 */
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  resize: vertical; /* 사용자가 세로로만 크기 조정 가능 */
}

/* ✅ 수정 시간 표시 박스 */

.timestamp-item {
  margin-bottom: 8px; /* 각 항목 간격 */
  color: #007bff; /* 파란색 텍스트 */
  text-decoration: underline; /* 밑줄 추가 */
  cursor : pointer;
}
/* 금지 커서와 스타일 변경 */
.timestamp-item.disabled {
  opacity: 0.5; /* 흐리게 표시 */
  cursor: not-allowed; /* 금지 커서 */
}
.timestamp-item:hover {
  background-color: #f0f0f0;
}

.textarea-wrapper.full-width {
  flex: 0 0 100%; /* textarea가 전체 너비를 차지 */
}


.timestamp-box {
  flex: 0 0 20%; /* 나머지 20% 할당 */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.timestamp-box label {
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 5px;
}

.timestamp {
  padding: 8px;
  background-color: #f9f9f9; /* 수정 시간 표시 영역 배경 */
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  height: 160px; /* 자동 높이 조정 */
  display: flex;
  flex-direction: column; /* 세로 정렬 */
  align-items: flex-start; /* 왼쪽 정렬 */
  gap: 8px; /* 각 항목 간격 추가 */
  color: #666; /* 텍스트 색상 */
  overflow-y: auto;
}

.return-button-wrapper {
  margin-top: 10px;
}

.return-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.return-button:hover {
  background-color: #0056b3;
}

/* ✅ 슬라이더 컨테이너 */
.custom-slider {
  position: relative;
  width: 300px;
  height: 30px;
  margin: 20px 0;
}


/* ✅ 슬라이더 트랙 (배경선) */
.custom-slider input[type="range"] {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  background: linear-gradient(to right, 
    #FF6F61 0%,   /* 왼쪽 초록색 */
    #FFD700 50%,  /* 중간 노란색 */
    #00FF00 100%  /* 오른쪽 빨간색 00FF00*/
  );
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  z-index: 1;
  position: relative;
}

/* ✅ 슬라이더 핸들 (드래그 원 + 점수 표시) */
.slider-thumb {
  position: absolute;
  top: -4px; /* 핸들 위치 조정 */
  transform: translateX(70%);
  color: white;
  font-size: 14px;
  font-weight: bold;
  padding: 5px 17px; /* 내부 패딩 추가 */
  border-radius: 20px; /* 둥근 직사각형 */
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 4px 8px rgba(168, 85, 247, 0.3);
  z-index: 2;
  pointer-events: none; /* 드래그 이벤트 방지 */
  line-height: 1.2;
  background: var(--slider-color, #A8E6CF); /* 기본 색상 (연한 초록) */
}

/* ✅ 점수 텍스트 포맷 */
.slider-thumb::after {
  margin-left: 2px;
  font-size: 12px;
  font-weight: normal;
}


/* ✅ 슬라이더 선택 영역 (선택된 부분) */
.slider-track {
  position: absolute;
  top: 50%;
  left: 0;
  height: 8px;
  border-radius: 10px;
  background: var(--slider-color, #A8E6CF); /* 선택된 부분 색상 */
  transform: translateY(-50%);
  z-index: 0;
  transition: width 0.2s ease-in-out;
}
</style>
